/* eslint-disable */
import { lazy } from "react";
import { DEFAULT_PATHS } from "../config";

const Dashboard = lazy(
  () => import("../features/recruiter/dashboard/pages/DashboardPage1")
);
const UploadResume = lazy(
  () =>
    import(
      "../features/recruiter/ai-screening/components/UploadResume/UploadResume"
    )
);
const AnalysisProfile = lazy(
  () =>
    import("../features/recruiter/ai-screening/components/Analysis/Analysis")
);
const AnalyzedProfiles = lazy(
  () =>
    import(
      "../features/recruiter/ai-screening/components/AnalyzedProfiles/AnalyzedProfiles"
    )
);
const Communication = lazy(
  () =>
    import(
      "../features/recruiter/ai-screening/components/Communication/pages/Communication"
    )
);
const Interview = lazy(
  () =>
    import(
      "../features/recruiter/ai-screening/components/Interview/pages/Interview"
    )
);
const Interviewprofilelist = lazy(
  () =>
    import(
      "../features/recruiter/ai-screening/components/Interview/pages/Interviewprofilelist"
    )
);
const UnMatchedCommunication = lazy(
  () =>
    import(
      "../features/recruiter/ai-screening/components/Communication/pages/UnMatchedCommunication"
    )
);
const ReadytoscheduleList = lazy(
  () =>
    import(
      "../features/recruiter/schedule/components/readytoschedule/readytoschedulelist"
    )
);
const Conforminterview = lazy(
  () =>
    import(
      "../features/recruiter/schedule/components/conforminterview/conforminterview"
    )
);
const Applicationcompleted = lazy(
  () =>
    import(
      "../features/recruiter/schedule/components/applicationcomplete/complete"
    )
);
const konbonDasborad = lazy(
  () => import("../features/recruiter/dashboard/pages/DashboardPage")
);
const InterviewScreen = lazy(
  () => import("../features/recruiter/candidates/pages/CandidatePage")
);
const ScheduleInterview = lazy(
  () => import("../features/recruiter/schedule/pages/ScheduleInterviewPage")
);
const ScheduleList = lazy(
  () => import("../features/recruiter/schedule/pages/ScheduleListPage")
);
const Profile = lazy(
  () => import("../features/recruiter/profile/pages/ProfilePage")
);
const Shortlist = lazy(
  () => import("../features/recruiter/shortlist/pages/ShortlistPage")
);
const Shortlisted = lazy(
  () =>
    import("../features/recruiter/profile/components/Shortlisted/Shortlisted")
);
const Analysisstaffing = lazy(
  () => import("../features/recruiter/staffing/pages/StaffingProject")
);
const Staffingview = lazy(
  () => import("../features/recruiter/staffing/pages/ProjectsView")
);
const Report = lazy(
  () =>
    import(
      "../features/recruiter/ai-screening/components/Interview/pages/Report"
    )
);
const VideoTranscriber = lazy(
  () =>
    import(
      "../features/recruiter/ai-screening/components/Interview/pages/VideoTranscriber"
    )
);
const AccountDetails = lazy(
  () => import("../features/recruiter/account-details/pages/AccountDetailsPage")
);
const ActivityCenter = lazy(
  () => import("../features/recruiter/activitycenter/pages/ActivityCenterPage")
);

const Notification = lazy(
  () => import("../features/recruiter/notification/components/NotificationList")
);

const appRoot = DEFAULT_PATHS.APP.endsWith("/")
  ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length)
  : DEFAULT_PATHS.APP;

const recruiterRoutes = {
  mainMenuItems: [
    {
      path: DEFAULT_PATHS.APP,
      exact: true,
      redirect: true,
      to: `${appRoot}/login`,
    },
  ],
  sidebarItems: [
    {
      path: `${appRoot}/dashboard`,
      label: "Dashboard",
      icon: "home",
      component: Dashboard,
    },
    {
      path: `${appRoot}/staffing`,
      label: "Job Campaign",
      icon: "file-text",
      component: Analysisstaffing,
    },
    {
      path: `${appRoot}/ai-screening`,
      label: "AI Screening",
      icon: "grid-1",
      component: UploadResume,
    },
    {
      path: `${appRoot}/analysis`,
      component: AnalysisProfile,
    },
    {
      path: `${appRoot}/analyzed_profiles`,
      component: AnalyzedProfiles,
    },
    {
      path: `${appRoot}/communication`,
      component: Communication,
    },
    {
      path: `${appRoot}/unmatchedcommunication`,
      component: UnMatchedCommunication,
    },
    {
      path: `${appRoot}/interview`,
      component: Interview,
    },
    {
      path: `${appRoot}/shortlist`,
      label: "Shortlist",
      icon: "list",
      component: Shortlist,
    },
    {
      path: `${appRoot}/staffingview`,
      component: Staffingview,
    },
    {
      path: `${appRoot}/candidate/:uuid/:scheduleId/:interviewid`,
      component: InterviewScreen,
    },
    {
      path: `${appRoot}/Readytoschedule`,
      label: "Schedule",
      icon: "grid-1",
      component: ReadytoscheduleList,
    },
    {
      path: `${appRoot}/confirm_interview/:candidate/:clsId/:interviewuuid`,
      component: Conforminterview,
    },
    {
      path: `${appRoot}/schedulelist`,
      icon: "grid-1",
      component: ScheduleList,
    },
    {
      path: `${appRoot}/Scheduleinterview/:id/:clsId/:job`,
      component: ScheduleInterview,
    },
    {
      path: `${appRoot}/application_complete/:id/:clsId/:interviewid`,
      component: Applicationcompleted,
    },
    {
      path: `${appRoot}/interview_profilelist`,
      component: Interviewprofilelist,
    },
    {
      path: `${appRoot}/profile`,
      component: Profile,
    },
    {
      path: `${appRoot}/shortlist`,
      component: Shortlist,
    },
    {
      path: `${appRoot}/shortlisted`,
      component: Shortlisted,
    },
    {
      path: `${appRoot}/konbon_dashboard`,
      component: konbonDasborad,
    },
    {
      path: `${appRoot}/account-details`,
      component: AccountDetails,
    },
    {
      path: `${appRoot}/Report/:interviewid`,
      component: Report,
    },
    {
      path: `${appRoot}/videoTranscriber/:interviewid`,
      component: VideoTranscriber,
    },
    {
      path: `${appRoot}/activitycenter`,
      label: "Activity Center",
      icon: "grid-1",
      component: ActivityCenter,
    },
    {
      path: `${appRoot}/notification`,
      component: Notification,
    },
  ],
};

export default recruiterRoutes;
